import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '@aveva/connect-web-core';
import { Observable } from 'rxjs';
import { AuthorizationError } from './authorization/authorization-error';
import { environment } from '../../environments/environment';

@Injectable()
export class ErmDevOpsGuard implements CanActivate {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.authenticationService.getUser()
      .then((user) => {
        if (!user) {
          this.authenticationService.navigateToSignIn();
          return false;
        }
        if (user.account !== environment.erm.ermDevOpsConnectAccountId) {
          this.router.navigate(['unauthorized', AuthorizationError.notDevOpsUser.errorCode]);
        }
        return true;
      });
  }
}
